import { Outlet, useRouterState } from "@tanstack/react-router";
import { Crumb, Page, PageBar } from "../components/ui/PageBar";
import { ADMIN_SECTIONS } from "./admin-sections";

/** The admin pages share a page bar and the page padding. Their sections are in the column (redesign spec §5.5). */
export function AdminLayout() {
  const pathname = useRouterState({ select: (s) => s.location.pathname });
  const current = ADMIN_SECTIONS.find((s) => pathname.startsWith(s.to));
  return (
    <>
      <PageBar>
        <Crumb>Admin</Crumb>
        {current ? <Crumb current>{current.label}</Crumb> : null}
      </PageBar>
      <Page>
        <Outlet />
      </Page>
    </>
  );
}
